var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssue4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7497 4.16853C12.906 4.32478 12.9841 4.51451 12.9841 4.73773C12.9841 4.96094 12.906 5.15067 12.7497 5.30692L6.68945 11.3672L5.55106 12.5056C5.39481 12.6618 5.20508 12.74 4.98186 12.74C4.75865 12.74 4.56892 12.6618 4.41267 12.5056L3.27427 11.3672L0.244141 8.33706C0.0878906 8.18081 0.00976562 7.99108 0.00976562 7.76786C0.00976562 7.54465 0.0878906 7.35492 0.244141 7.19867L1.38253 6.06027C1.53878 5.90402 1.72852 5.8259 1.95173 5.8259C2.17494 5.8259 2.36468 5.90402 2.52093 6.06027L4.98186 8.52958L10.4729 3.03014C10.6292 2.87389 10.8189 2.79576 11.0421 2.79576C11.2653 2.79576 11.4551 2.87389 11.6113 3.03014L12.7497 4.16853Z",
    fill: "#E30000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssue4);
export default __webpack_public_path__ + "static/media/issue4.b6433939ffe7806d3f05ad5dd99c9f8d.svg";
export { ForwardRef as ReactComponent };